import { FC, HTMLAttributes } from 'react';
import './Sidebar.css';
import Stack from '@/shared/components/Stack/Stack';

interface SidebarProps extends HTMLAttributes<HTMLElement> {
}

const Sidebar: FC<SidebarProps> = ({ 
  children, 
  className = '', 
  ...props 
}) => {
  return (
    <Stack as="aside" direction="vertical" className={`sidebar ${className}`} {...props}>
      {children}
    </Stack>
  );
};

export default Sidebar; 